import script from "./mobile-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./mobile-menu.vue?vue&type=script&setup=true&lang=ts"

import "./mobile-menu.vue?vue&type=style&index=0&id=3089f5e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3089f5e2"]])

export default __exports__